import React from "react";
import { useParams, useLocation } from "react-router-dom";
const ThakYouFormSubmit = () => {
  const { id, cid } = useParams();

  return (
    <div className="container thank">
      <div className="d-flex justify-content-center align-items-center">
        <img src="/img/prize.png" alt="" className="main-img" />
      </div>
      <h2 className="text-center">
        Your form has been submitted successfully. Our recruiters will <br />{" "}
        get in touch with you shortly.
      </h2>
      <p className="text-center my-4">
        There is an optional test. If you want to proceed to the test, please{" "}
        <br />
        proceed and click <strong>Next</strong>.
      </p>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <a href={"/instruction/" + id + "/" + cid}>
          <img src="/img/next.png" alt="" className="d-flex icon" />
        </a>
        <p>
          <a href={"/instruction/" + id + "/" + cid}>
            <strong>Next</strong>
          </a>
        </p>
      </div>
    </div>
  );
};

export default ThakYouFormSubmit;
